import { Col, Modal, Row, Table } from "antd";
import moment from "moment";
import React from "react";
import lodash from "lodash";

const CashupDiscountList = (props) => {
  // -------------------------- VAR --------------------------
  const { open, setOpen, data } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleCancel = () => {
    setOpen(false);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      key: "time",
      title: "Time",
      dataIndex: "createAt",
      align: "center",
      render: (value) => renderTime(value),
    },
    {
      key: "jobName",
      title: "Job Name",
      dataIndex: "jobName",
      align: "center",
      render: (value) => renderName(value),
    },
    {
      key: "value",
      title: "Value",
      dataIndex: "value",
      align: "center",
      render: (value) => renderValue(value),
    },
  ];

  const renderTime = (value) => {
    const time = moment(value?.toDate()).format("hh:mm A");
    return <Row>{time}</Row>;
  };
  const renderName = (value) => {
    return <Row>{value}</Row>;
  };
  const renderValue = (value) => {
    return <Row justify="end">${value}</Row>;
  };

  const renderDiscountList = () => {
    const sortData = lodash.sortBy(data, ["createAt"]);
    if (data) {
      return (
        <Col span={24}>
          <Table
            size="small"
            columns={columns}
            dataSource={sortData}
            pagination={false}
          />
        </Col>
      );
    }
    return null;
  };
  // -------------------------- MAIN --------------------------
  const title = "Discount from job";
  return (
    <Modal title={title} open={open} onCancel={handleCancel} footer={false}>
      <Col span={24}>
        <Row gutters={[20, 20]} align="middle">
          {renderDiscountList()}
        </Row>
      </Col>
    </Modal>
  );
};
export default CashupDiscountList;
